import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-r from-purple-600 to-pink-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 animate-fade-in">
          Ready to build your link-in-bio page?
        </h2>
        <p className="text-xl text-white/90 mb-8 animate-slide-up">
          Join thousands of creators, entrepreneurs, and professionals who are already using QuickLinks to share their world.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-scale-in">
          <Link
            to="/signup"
            className="bg-white text-purple-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transform hover:scale-105 transition-all text-center"
          >
            Get Started Free
          </Link>
          <button className="bg-transparent text-white px-8 py-4 rounded-lg text-lg font-semibold border-2 border-white hover:bg-white hover:text-purple-600 transition-all">
            View Demo
          </button>
        </div>
        <p className="text-white/80 text-sm mt-6">
          No credit card required • Set up in minutes • Cancel anytime
        </p>
      </div>
    </section>
  );
};

export default CTA; 